import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import classNames from 'classnames';
import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent';
import ProductImage from 'components/Elements/ProductImage';

export default function ModalExitSales({version = 'full', ...props}) {
  const {isOpen, toggle} = useExitIntent(60000);

  return (
    <Modal className="modal-exit-intent modal-exit-intent-empowerment" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Before you go…</h4>
          {version === 'sales' ? (
            <>
              <p>
                This is your chance to get <br className="d-none d-md-block" />
                <i>Tackling Type 2</i> for 40% off.
              </p>
              <p className="mb-0">
                Get it before the price goes up <br className="d-none d-lg-block d-xl-none" />
                and enjoy <br className="d-none d-xl-block" />
                all the diabetes-busting recipes, life-changing lessons, community, and ongoing support{' '}
                <br className="d-none d-lg-block" />
                for years to come!
              </p>
            </>
          ) : (
            <>
              <p>
                You’re about to miss getting <br className="d-none d-lg-block d-xl-none" />
                all the <br className="d-none d-xl-block" />
                diabetes-busting recipes, <br className="d-none d-lg-block d-xl-none" />
                life-changing <br className="d-none d-xl-block" />
                lessons, community, and ongoing support <br className="d-none d-xl-block" />
                inside <br className="d-none d-lg-block d-xl-none" />
                <i>Tackling Type 2.</i>
              </p>
              <p className="mb-0">
                It’s not too late to change your mind and get everything you need to be your healthiest!
              </p>
            </>
          )}

          <Row className="d-flex align-items-center mt-5">
            <Col xs="12" lg="6" className="mb-4 mb-lg-0 pr-lg-0">
              <Button
                className="text-uppercase text-white btn-exit-orange"
                color="cta"
                onClick={toggle}
                block
                activeClass="active"
                spy={true}
                offset={-55}
                to="course-cta-1"
                smooth={true}
                href="#"
                tag={Link}
              >
                Yes, I want to protect my health
              </Button>
            </Col>
            <Col xs="12" lg="6">
              <Button className="text-uppercase text-800 text-white" color="exit-gray" onClick={toggle} block>
                No thanks, I’ll take my chances
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="landing-exit-image-col background-light-gray order-lg-1 d-flex flex-column">
          <div className="my-auto px-3 px-lg-1 py-5">
            <ProductImage />
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
